import styled, { keyframes } from 'styled-components';
import { palette } from '../../theme/colors';
import type { AppToastVariant } from './appToast.types';

const toastIn = keyframes`
  from { opacity: 0; transform: translateY(100%); }
  to   { opacity: 1; transform: translateY(0);    }
`;

const toastOut = keyframes`
  from { opacity: 1; transform: translateY(0);    }
  to   { opacity: 0; transform: translateY(100%); }
`;

export const variantIconBg: Record<AppToastVariant, string> = {
  success: palette.appleGreen,
  error: palette.danger,
};

export const SCard = styled.div<{ $visible: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  border-radius: 10px;
  border: 1px solid ${palette.whiteWithZeroPointZeroEightOpacity};
  background: ${palette.raisinBlack};
  padding: 14px 16px;
  min-width: 65vw;
  box-shadow: 0 12px 32px ${palette.shadowColor};
  animation-name: ${({ $visible }) => ($visible ? toastIn : toastOut)};
  animation-duration: ${({ $visible }) => ($visible ? '200ms' : '150ms')};
  animation-timing-function: ${({ $visible }) =>
    $visible ? 'cubic-bezier(0.22, 1, 0.36, 1)' : 'cubic-bezier(0.4, 0, 1, 1)'};
  animation-fill-mode: forwards;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    transform: translateY(${({ $visible }) => ($visible ? '0' : '100%')});
  }
`;

export const SIconWrap = styled.span<{ $bg: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${({ $bg }) => $bg};
  color: ${palette.white};
`;

export const STextCol = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const STitle = styled.span`
  color: ${palette.white};
  font-family: 'Roboto-Bold', Roboto, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const SMessage = styled.span`
  color: ${palette.white};
  font-family: 'Roboto-Medium', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;

export const SCloseButton = styled.button`
  background: transparent;
  border: none;
  padding: 6px;
  margin: -2px -2px -2px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${palette.white};
  flex-shrink: 0;
  opacity: 0.6;

  &:hover,
  &:focus-visible {
    opacity: 1;
  }

  &:active {
    opacity: 0.7;
  }
`;
